const createServiceObject = (serviceType = "WebPage", audience, category, brand) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType,
  ...audience && { audience },
  ...category && { category },
  ...brand && { brand }
});
const setServiceObject = (serviceType, audience, category, brand) => {
  if (typeof window === "undefined") {
    return;
  }
  if (!window.grandvision) {
    window.grandvision = {};
  }
  window.grandvision.service = createServiceObject(serviceType, audience, category, brand);
};
export {
  setServiceObject
};
//# sourceMappingURL=service.js.map
